module.exports = __webpack_public_path__ + "img/stock3.921b6d6f.png";